import { render, staticRenderFns } from "./filters-select.vue?vue&type=template&id=8b2ca2a6&scoped=true&"
import script from "./filters-select.js?vue&type=script&lang=js&"
export * from "./filters-select.js?vue&type=script&lang=js&"
import style0 from "./filters-select.scss?vue&type=style&index=0&id=8b2ca2a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2ca2a6",
  null
  
)

export default component.exports